module.exports = __webpack_public_path__ + "img/forestorytellingtour_option_01.ad35d0f8.jpg";